import * as React from "react";
import { Bug, Clock, MapPin, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const differentiators = [{
  title: "Fully Licensed & Insured",
  description: "FDACS Licensed Pest Control and Termite Operator ensuring safe, compliant, and professional treatments for your property.",
  icon: ShieldCheck
}, {
  title: "Local Florida Experts",
  description: "Proudly serving Punta Gorda, Port Charlotte, Cape Coral, Burnt Store, and North Fort Myers with localized expertise.",
  icon: MapPin
}, {
  title: "Comprehensive Control",
  description: "Expert, targeted solutions for ants, termites, roaches, spiders, mosquitos, millipedes, and other common Florida pests.",
  icon: Bug
}, {
  title: "Fast & Reliable Service",
  description: "Focused on solving your pest problems quickly and reliably. We show up on time and get the job done right the first time.",
  icon: Clock
}];
export default function TrustBuildingDifferentiators() {
  return <section id="trustbuildingdifferentiators" className="bg-background py-20 px-4 md:px-8 lg:py-28">
      <div className="mx-auto max-w-6xl flex flex-col items-center">
        <h2 className="font-sans text-foreground text-center text-3xl md:text-5xl font-bold uppercase tracking-wide mb-12 md:mb-16 max-w-3xl">
          Why Choose Peace River Pest Control
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 w-full mb-16">
          {differentiators.map((item, i) => <Card key={i} data-index={i} className="rounded-none border-2 border-primary bg-card shadow-none hover:shadow-md transition-shadow duration-300 relative overflow-hidden group">
              {}
              <div className="absolute top-0 left-0 w-full h-1 bg-primary transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out" />
              
              <CardHeader className="flex flex-row items-start gap-5 pb-2 pt-8">
                <div className="bg-primary/10 p-3 rounded-none border border-primary/30 shrink-0">
                  <item.icon className="w-8 h-8 text-primary" strokeWidth={2.5} />
                </div>
                <CardTitle className="font-sans text-xl md:text-2xl uppercase text-card-foreground mt-1">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="pb-8 pl-[5.25rem]">
                <p className="font-serif text-lg text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-sans text-lg md:text-xl px-10 py-7 uppercase tracking-wider shadow-lg hover:shadow-xl transition-all duration-300">
          <Link to="/ContactPage">Get Your Free Quote Today</Link>
        </Button>
      </div>
    </section>;
}